import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const NotificationItem = ({ notification, onMarkAsRead, onNavigate }) => {
  const navigate = useNavigate();

  const getNotificationIcon = (type) => {
    const icons = {
      'clap': 'Heart',
      'comment': 'MessageCircle',
      'follow': 'UserPlus',
      'collaboration': 'Users',
      'mention': 'AtSign',
      'system': 'Bell'
    };
    return icons?.[type] || 'Bell';
  };

  const getNotificationColor = (type) => {
    const colors = {
      'clap': 'text-error',
      'comment': 'text-accent',
      'follow': 'text-success',
      'collaboration': 'text-primary',
      'mention': 'text-warning',
      'system': 'text-muted-foreground'
    };
    return colors?.[type] || 'text-muted-foreground';
  };

  const handleClick = () => {
    if (onMarkAsRead) {
      onMarkAsRead(notification?.id);
    }

    // Determine where to navigate based on notification type and related data
    const articleId = notification?.relatedArticleId;
    const message = notification?.message || '';

    // System notifications about review (revision requested, rejected, approved)
    if (notification?.type === 'system' && articleId) {
      if (message.includes('تعديل') || message.includes('مرفوض') || message.includes('رفض')) {
        // Revision or rejection — open the editor so user can fix and resubmit
        if (onNavigate) onNavigate();
        navigate(`/creator-studio/${articleId}`);
        return;
      }
      if (message.includes('الموافقة') || message.includes('نُشر')) {
        // Article was approved — view the published article
        if (onNavigate) onNavigate();
        navigate(`/article/${articleId}`);
        return;
      }
      // Generic system notification with article — view the article
      if (onNavigate) onNavigate();
      navigate(`/article/${articleId}`);
      return;
    }

    // Clap or comment on an article
    if ((notification?.type === 'clap' || notification?.type === 'comment') && articleId) {
      if (onNavigate) onNavigate();
      navigate(`/article/${articleId}`);
      return;
    }

    // Follow notification — navigate to the follower's profile
    if (notification?.type === 'follow' && notification?.relatedUserId) {
      if (onNavigate) onNavigate();
      navigate(`/user/${notification.relatedUserId}`);
      return;
    }
  };

  return (
    <div 
      className="flex items-start gap-3 p-3 md:p-4 bg-transparent transition-all duration-300 cursor-pointer hover:bg-muted/20 rounded-lg"
      onClick={handleClick}
    >
      <div className="flex-shrink-0 shadow-[0_2px_8px_rgba(0,0,0,0.06)]">
        <Icon 
          name={getNotificationIcon(notification?.type)} 
          size={20} 
          className={`${getNotificationColor(notification?.type)}`}
        />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-base font-body text-foreground mb-1">
          {notification?.type === 'follow' && notification?.relatedUserName ? (
            <>
              <span
                className="font-bold text-[var(--color-primary)] hover:underline cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  if (onMarkAsRead) onMarkAsRead(notification.id);
                  if (onNavigate) onNavigate();
                  navigate(`/user/${notification.relatedUserId}`);
                }}
              >
                {notification.relatedUserName}
              </span>
              {' بدأ بمتابعتك'}
            </>
          ) : (notification?.relatedUserId && notification?.relatedUserName && (notification?.type === 'clap' || notification?.type === 'comment')) ? (
            (() => {
              const msg = notification?.message || '';
              const parts = msg.split('أحدهم');
              const handleUserClick = (e) => {
                e.stopPropagation();
                if (onMarkAsRead) onMarkAsRead(notification.id);
                if (onNavigate) onNavigate();
                navigate(`/user/${notification.relatedUserId}`);
              };
              return (
                <>
                  {parts[0]}
                  <span
                    className="font-bold text-[var(--color-primary)] hover:underline cursor-pointer"
                    onClick={handleUserClick}
                  >
                    {notification.relatedUserName}
                  </span>
                  {parts[1] || ''}
                </>
              );
            })()
          ) : (
            notification?.message
          )}
        </p>
        <p className="text-xs text-muted-foreground">
          {notification?.time}
        </p>
      </div>
      {!notification?.isRead && (
        <div className="w-2 h-2 rounded-full bg-primary flex-shrink-0 mt-2"></div>
      )}
    </div>
  );
};

export default NotificationItem;
